import { render, staticRenderFns } from "./UserDetailLayout.vue?vue&type=template&id=2a5b4594&scoped=true&lang=pug&"
import script from "./UserDetailLayout.vue?vue&type=script&lang=js&"
export * from "./UserDetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailLayout.vue?vue&type=style&index=0&id=2a5b4594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b4594",
  null
  
)

export default component.exports